import 'css-chunksrc/client/pages/planzoneLogsPage/logs/styles.scss';export default {
  "logs": "_logs_s0bu2_1",
  "log": "_log_s0bu2_1",
  "list": "_list_s0bu2_17",
  "skeleton": "_skeleton_s0bu2_26"
};